(() => {
  if (window.PuzzlePupFunnelDrawer) return;

  let returnFocus = null;

  function root() {
    return document.querySelector('[data-pp-funnel-cart-drawer]');
  }

  function focusable(container) {
    return Array.from(container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'));
  }

  function open() {
    const drawer = root();
    if (!drawer) return false;
    returnFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pp-funnel-drawer-open');
    window.requestAnimationFrame(() => drawer.querySelector('[data-pp-funnel-drawer-close]')?.focus());
    return true;
  }

  function close() {
    const drawer = root();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pp-funnel-drawer-open');
    if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
  }

  async function changeLine(button) {
    const key = button.dataset.key;
    const quantity = Math.max(0, Number(button.dataset.quantity || 0));
    if (!key) return;
    button.disabled = true;
    const status = root()?.querySelector('[data-pp-funnel-drawer-status]');
    if (status) status.textContent = 'Updating cart…';
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || 'The cart could not be updated.');
      await window.PuzzlePupStorefront?.refreshCartSurfaces?.();
      open();
      const nextStatus = root()?.querySelector('[data-pp-funnel-drawer-status]');
      if (nextStatus) nextStatus.textContent = 'Cart updated.';
    } catch (error) {
      button.disabled = false;
      if (status) status.textContent = error.message;
    }
  }

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-pp-funnel-drawer-close]');
    if (closeButton) {
      event.preventDefault();
      close();
      return;
    }
    const changeButton = event.target.closest('[data-pp-funnel-cart-change]');
    if (changeButton) {
      event.preventDefault();
      changeLine(changeButton);
    }
  });

  document.addEventListener('keydown', (event) => {
    const drawer = root();
    if (!drawer?.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const controls = focusable(drawer);
    if (!controls.length) return;
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.PuzzlePupFunnelDrawer = Object.freeze({ open, close });
})();